module.exports = __webpack_public_path__ + "img/index-section6-friend7.d615e228.svg";